/* ==========================================================================
   Chat widget layering — enforcement
   Tidio writes its z-index as an INLINE `!important` style on its own
   container/iframe, which no stylesheet can override (see
   snippets/custom-inline-css.liquid). An inline style CAN be replaced by another
   inline write, so set the property directly on the element and keep it there.

   Target is z-index 15: above ordinary page content, below the theme's nav
   overlay (20), header/mega menu (30) and cart drawer (40).
   ========================================================================== */
(function () {
  var Z_INDEX = '15';
  var SELECTOR = '#tidio-chat, #tidio-chat-iframe, #tidio-chat-code, tidio-chat';
  var POLL_MS = 400;
  var GIVE_UP_MS = 30000; // the widget script loads late; stop looking after 30s

  var observed = [];

  function pin(el) {
    if (el.style.getPropertyValue('z-index') !== Z_INDEX) {
      el.style.setProperty('z-index', Z_INDEX, 'important');
    }
  }

  function apply() {
    var found = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < found.length; i++) {
      var el = found[i];
      pin(el);
      // Tidio rewrites its inline style when the panel opens/closes — watch the
      // element itself (cheap) rather than the whole document, and re-pin.
      if (observed.indexOf(el) === -1) {
        observed.push(el);
        new MutationObserver(function (records) {
          pin(records[0].target);
        }).observe(el, { attributes: true, attributeFilter: ['style'] });
      }
    }
    return found.length > 0;
  }

  apply();

  var startedAt = Date.now();
  var poll = window.setInterval(function () {
    var haveAll = apply();
    if ((haveAll && observed.length >= 2) || Date.now() - startedAt > GIVE_UP_MS) {
      window.clearInterval(poll);
    }
  }, POLL_MS);
})();
